import userData from "./userData";
import refreshUser from "./refresh";
import clientId from "./clientid";
import { combineReducers } from 'redux';

const allReducers = combineReducers({
    userData,
    refreshUser,
    clientId
})

export default allReducers;